import { module } from 'modujs';
import { copyToClipboard } from "../utils/html"

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'onClick'
        }
    }

    onClick(e) {
        e.preventDefault();
        e.stopPropagation();

        copyToClipboard(e.currentTarget)
    }
}
